// @ts-nocheck
import React, {useContext} from "react";
import {ResponsiveBar} from "@nivo/bar";
import ChartCard from "./ChartCard";
import StyleContext from "../../../contexts/StyleContext";
import {semifinalists} from "../data/fifaData";
import {FIFA_PALETTE, getNivoTheme} from "./chartTheme";

// 4.7 Semi-finalist alignment (bar): how many of each year's top-4 ranked teams
// reached the semis (0-4). 2026 is the only 4-of-4, highlighted in the accent.

// Teams appearing in both the ranked top-four and the actual semifinalists.
const overlap = (topFour, semis) => {
  const set = new Set(semis);
  return topFour.filter(team => set.has(team));
};

const TeamList = ({teams, aligned}) => (
  <ul className="fifa-tooltip__list">
    {teams.map(team => (
      <li
        key={team}
        className={aligned.has(team) ? "fifa-tooltip__hit" : undefined}
      >
        {team}
      </li>
    ))}
  </ul>
);

const AlignmentTooltip = ({indexValue, value, data}) => {
  const aligned = new Set(overlap(data.topFour, data.semifinalists));
  return (
    <div className="fifa-tooltip">
      <span className="fifa-tooltip__title">
        {indexValue} — {value} of 4 top-ranked reached the semis
      </span>
      <div className="fifa-tooltip__cols">
        <div className="fifa-tooltip__col">
          <p className="fifa-tooltip__col-title">Pre-tournament top 4</p>
          <TeamList teams={data.topFour} aligned={aligned} />
        </div>
        <div className="fifa-tooltip__col">
          <p className="fifa-tooltip__col-title">Semi-finalists</p>
          <TeamList teams={data.semifinalists} aligned={aligned} />
        </div>
      </div>
    </div>
  );
};

export default function SemifinalistAlignment() {
  const {isDark} = useContext(StyleContext);

  const footnote = (
    <span className="fifa-legend">
      <span className="fifa-legend__item">
        <span
          aria-hidden="true"
          style={{
            display: "inline-block",
            width: 12,
            height: 12,
            borderRadius: 3,
            background: FIFA_PALETTE.accent,
            marginRight: 6,
            verticalAlign: "middle"
          }}
        />
        All four (4-of-4)
      </span>
      <span className="fifa-legend__note">
        Bars count how many of each tournament's four top-ranked teams reached
        the semi-finals. 2026 is the only 4-of-4 — hover to see which teams
        overlapped. 2026 used a 48-team / 104-match format (a documented
        caveat).
      </span>
    </span>
  );

  return (
    <ChartCard
      title="Semi-finalist alignment"
      takeaway="2026 is the only tournament where all four top-ranked teams reached the semis (highlighted)."
      footnote={footnote}
    >
      <ResponsiveBar
        data={semifinalists}
        keys={["topFourInSemis"]}
        indexBy="year"
        margin={{top: 20, right: 24, bottom: 56, left: 60}}
        padding={0.3}
        valueScale={{type: "linear"}}
        minValue={0}
        maxValue={4}
        gridYValues={[0, 1, 2, 3, 4]}
        colors={({data}) =>
          data.allFour ? FIFA_PALETTE.accent : FIFA_PALETTE.primary
        }
        borderRadius={3}
        enableLabel={true}
        label={d => d.value}
        labelSkipHeight={14}
        labelTextColor="#ffffff"
        axisBottom={{
          legend: "World Cup",
          legendPosition: "middle",
          legendOffset: 44
        }}
        axisLeft={{
          legend: "Top-4 ranked teams in semis",
          legendPosition: "middle",
          legendOffset: -46,
          tickValues: [0, 1, 2, 3, 4]
        }}
        tooltip={AlignmentTooltip}
        theme={getNivoTheme(isDark)}
        animate={true}
        motionConfig="gentle"
        role="img"
      />
    </ChartCard>
  );
}
